import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { getFolderPaths } from '../../slices/thunks';

const useFolderPaths = (data, enabled = true) => {
	const dispatch = useDispatch();

	const idsKey = useMemo(() => {
		const ids = data?.ids;
		if (!Array.isArray(ids) || ids.length === 0) return '';
		return [...ids].sort().join(',');
	}, [data?.ids]);

	const middlePath = data?.middle_path ?? '';

	const selector = createSelector(
		state => state.Guides,
		guides => ({
			folderPaths: guides.folderPaths,
			isLoading: guides.isLoading,
			isLoaded: guides.isLoaded,
			isError: guides.isError,
		})
	);

	const { folderPaths, isLoading, isLoaded, isError } = useSelector(selector);

	useEffect(() => {
		if (!enabled || !idsKey) return;
		dispatch(
			getFolderPaths({
				ids: data.ids,
				middle_path: middlePath,
			})
		);
	}, [dispatch, enabled, idsKey, middlePath]);

	return { folderPaths, isLoading, isLoaded, isError };
};

export default useFolderPaths;
